import { Icon } from '@iconify/react';
import React from 'react';
import XIcon from "@mui/icons-material/X";

export default function SocialWidget() {
  return (
    <div className="cs_social_links_wrap">
      <h2>Follow Us</h2>
      <div className="cs_social_links">
        <a
          href="https://www.facebook.com/NHWMOH"
          rel="noopener noreferrer"
          target="_blank"
        >
          <Icon icon="fa-brands:facebook-f" />
        </a>
        <a
          href="https://www.youtube.com/@nhwmoh"
          rel="noopener noreferrer"
          target="_blank"
        >
          <Icon icon="fa-brands:youtube" />
        </a>
        <a
          href="https://www.linkedin.com/company/nhwm/?viewAsMember=true"
          rel="noopener noreferrer"
          target="_blank"
        >
          <Icon icon="fa-brands:linkedin-in" />
        </a>
        <a
          href="https://x.com/NHWMOH"
          rel="noopener noreferrer"
          target="_blank"
        >
          <XIcon />
        </a>
        <a
          href="https://www.instagram.com/nhwmoh2021"
          rel="noopener noreferrer"
          target="_blank"
        >
          <Icon icon="fa-brands:instagram" />
        </a>
      </div>
    </div>
  );
}
